import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { genericCustomStoreService } from 'src/app/shared/services/genericCustomStore.service';
import { publicSettingService } from 'src/app/shared/services/hr/publicSetting';
import { ObjectsService } from 'src/app/shared/services/hr/objects.service';
import { SuperComponent } from 'src/app/pages/super/super.component';
import { TranslateService } from '@ngx-translate/core';
import { slideToggleAnimation } from 'src/app/core/menue.anmations';

@Component({
  selector: 'app-add-edit-job-title-structure',
  templateUrl: './add-edit-job-title-structure.component.html',
  styleUrls: ['./add-edit-job-title-structure.component.scss'],
 animations: [slideToggleAnimation]
})
export class AddEditJobTitleStructureComponent extends SuperComponent implements OnInit {
  dataSource: any = []; // Data source for the grid
  managemetList: {}[] = [];
  jobTitleList: {}[] = [];
  active_id: number = 0;
  isGridValid: boolean = false; // Flag to track button state
  constructor(
    public _publicSettingService: publicSettingService,
    gt: genericCustomStoreService,
    Objects: ObjectsService,
    public router: Router,
    translate: TranslateService
  ) {
    super(Objects, translate, gt);
    this.button = Objects.button;
    gt.getdropdowndata("Management").subscribe((res: []) => (this.managemetList = res));
    gt.getdropdowndata("JobTitle").subscribe((res: []) => (this.jobTitleList = res));
    this._publicSettingService.$JOB_TITLE_ID.subscribe((res) => {
      this.active_id = res;
      if (this.active_id != 0) {
        this._publicSettingService.byKey("JobTitleStructure", this.active_id).subscribe((res) => {
          this.dataSource = res;
          this.checkGridValidity();
        });
      }
    });
  }

  ngOnInit(): void { }

  onInitNewRowE(e: any) {
    e.data.id = 0;
  }

  // backToMainPage(e: string) {
  //   if (e === "back") {
  //     this.router.navigate(["hr/JobTitleStructure"]);
  //   }
  // }

  onFormSubmit(e: any) {
    let data = {
      jobTitleStructureDTO: this.dataSource,
    };
    if (this.active_id !== 0) {
      this._publicSettingService.update("JobTitleStructure", data).subscribe(() => {
        this.router.navigate(["hr/JobTitleStructure"]);
      });
    } else {
      this._publicSettingService.add("JobTitleStructure", data).subscribe(() => {
        this.router.navigate(["hr/JobTitleStructure"]);
      });
    }
  }

  onRowInserted(event: any) {
    // No need to manually add the row; just check grid validity
    this.checkGridValidity();
  }
  
  onRowRemoved(event: any) {
    // No need to manually remove the row; the grid already updates the dataSource
    this.checkGridValidity();
  }
  
  checkGridValidity() {
    // Use the length of the current dataSource to determine validity
    this.isGridValid = this.dataSource && this.dataSource.length > 0;
  }
}
